var module = angular.module('main.customerorder');

module.component('caCustomerOrderPayments',{
    templateUrl: 'main/customerorder/customerordersearch/customerordercontent/customerorderpayments.cmp.tpl.html',
    bindings: {
        customerOrder: '<',
        navigated: '&'
    },
    controllerAs: 'vm',
    controller: componentController
});

// @ngInject
function componentController($state, $translate) {
    var vm = this;

    //Properties
    vm.customerOrder = {};

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    function onInit() {
    }
    function onChanges() {
    }

}
